export default class IndexResponse<T> {
  content: T[];

  constructor(entity: IndexResponse<T>) {
    this.content = entity.content;
  }
}



// WEBPACK FOOTER //
// ./src/value-objects/IndexResponse.tsx